import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const ConsultantUser = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default ConsultantUser